import React from "react";
import "./hero.css";

const Hero = () => {
  return (
    <div className="heroMain">
      <div className="heroImg"></div>
      <div className="mainTitle">
        <p className="topTitle">
          <b>The Magic</b> of creation
        </p>
        <p className="subTitle">
          Lorem ipsum dolor, sit amet consectetur adipisicing elit.
          Exercitationem, suscipit minus placeat odio tenetur rerum eaque voluptas quis voluptate, aliquam magni?.
        </p>
        <div className="twobtns">
          <button>our works</button>
          <button>contact us</button>
        </div>
        <div className="dot">
          <p>
            <i class="fas fa-circle"></i>
          </p>
        </div>
      </div>
    </div>
  );
};
export default Hero;
